import {
  provideSoftAppsModule,
  withSoftAppsModuleInfo,
  withSoftAppsModuleNavItem,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import {
  SOFTLINE_CONFIG_WORKFLOW_TYPE,
  WorkflowTypeConfig,
} from '@softapps/gewerbe/workflow';
import { getModuleGroupByName } from '@softline/application';
import { default as de } from '../i18n/de.json';
import { default as en } from '../i18n/en.json';
import { ComplaintRepository } from './repositories/complaint.repository';
import { claimReportRoutes } from './claim-report.routes';
import {
  ClaimReportModuleConfig,
  DEFAULT_CLAIM_REPORT_CONFIG,
  SOFTLINE_CONFIG_CLAIM_REPORT,
  SOFTLINE_MODULE_CLAIM_REPORT,
  SOFTLINE_PERMISSION_CLAIM_REPORT,
} from './claim-report.shared';

export const provideClaimReportModule = (config?: ClaimReportModuleConfig) => {
  return [
    {
      provide: SOFTLINE_CONFIG_CLAIM_REPORT,
      useValue: { ...DEFAULT_CLAIM_REPORT_CONFIG, ...config },
    },
    {
      provide: SOFTLINE_CONFIG_WORKFLOW_TYPE,
      useValue: {
        type: 'COMPLAINT',
        getRoute: (workflow) => ['/claim-report/workflow', String(workflow.id)],
        getSummary: () =>
          import('./pages/complaint-workflow/complaint-workflow.summary').then(
            (m) => m.getComplaintWorkflowSummary
          ),
        getSummaryProviders: () => [ComplaintRepository],
        viewModes: ['table'],
      } satisfies WorkflowTypeConfig,
      multi: true,
    },
    provideSoftAppsModule(
      {
        name: SOFTLINE_MODULE_CLAIM_REPORT,
        title: '#CLAIM_REPORT.TITLE',
        icon: 'fa-regular fa-burst',
        route: '/claim-report',
        permission: SOFTLINE_PERMISSION_CLAIM_REPORT,
        group: getModuleGroupByName('Gewerbe'),
      },
      withSoftAppsModuleRoutes({ app: claimReportRoutes }),
      withSoftAppsModuleTranslation({ de, en }),
      withSoftAppsModuleNavItem([
        {
          name: 'claim-report-main',
          title: '#CLAIM_REPORT.MAIN_PAGE_TITLE',
          icon: 'fa-regular fa-house',
          routerLink: ['/claim-report/main'],
          entry: true,
        },
      ]),
      withSoftAppsModuleInfo({
        library: '@softapps/gewerbe/claim-report',
        description: 'Reklamationen erfassen und nachverfolgen.',
      })
    ),
  ];
};
